import { render, staticRenderFns } from "./customerSalesPrices.vue?vue&type=template&id=6331d4b9"
import script from "./customerSalesPrices.vue?vue&type=script&lang=js"
export * from "./customerSalesPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports